import OpticksPillDemo from "@/components/ui/OpticksPlanPillIndicator/plan-pills/OpticksPillDemo";
import OpticksPillFreeTrial from "@/components/ui/OpticksPlanPillIndicator/plan-pills/OpticksPillFreeTrial";
import OpticksPillPlanLite from "@/components/ui/OpticksPlanPillIndicator/plan-pills/OpticksPillPlanLite";
import OpticksPillPlanPro from "@/components/ui/OpticksPlanPillIndicator/plan-pills/OpticksPillPlanPro";
import OpticksPillPlanMax from "@/components/ui/OpticksPlanPillIndicator/plan-pills/OpticksPillPlanMax";
import OpticksPillEnterprise from "@/components/ui/OpticksPlanPillIndicator/plan-pills/OpticksPillEnterprise";
import OpticksPillSumo10 from "./plan-pills/OpticksPillSumo10";
import OpticksPillSumo50 from "./plan-pills/OpticksPillSumo50";
import OpticksPillSumo100 from "./plan-pills/OpticksPillSumo100";
import OpticksPillSumo300 from "./plan-pills/OpticksPillSumo300";
import OpticksPillSumo500 from "./plan-pills/OpticksPillSumo500";
import OpticksPillSumo1M from "./plan-pills/OpticksPillSumo1M";
import { routesMap } from "@/components/routes/routes";
import { useNavigate } from "react-router-dom";
import OpticksSkeletonContainer from "../OpticksSkeletons/OpticksSkeletonContainer";
import { PLAN_MODE, SELFSERVICE_PAID_PLANS } from "@/utilities/constants";
import "./OpticksPlanPillIndicator.css";

interface Props {
  planType: string;
  width?: number;
  height?: number;
  withLink?: boolean;
  loading?: boolean;
  display?: string;
}

const OpticksPlanPillIndicator = ({
  planType,
  width,
  height,
  withLink,
  loading,
  display,
}: Props) => {
  const navigate = useNavigate();

  const renderPlanPill = () => {
    const sizeProps = { width, height };

    switch (planType) {
      case PLAN_MODE.DEMO:
        return <OpticksPillDemo {...sizeProps} />;
      case PLAN_MODE.FREE:
        return <OpticksPillFreeTrial {...sizeProps} />;
      case SELFSERVICE_PAID_PLANS.LITE:
        return <OpticksPillPlanLite {...sizeProps} />;
      case SELFSERVICE_PAID_PLANS.PRO:
        return <OpticksPillPlanPro {...sizeProps} />;
      case SELFSERVICE_PAID_PLANS.MAX:
        return <OpticksPillPlanMax {...sizeProps} />;
      case "enterprise":
        return <OpticksPillEnterprise {...sizeProps} />;
      case "sumo_plan1":
        return <OpticksPillSumo10 {...sizeProps} />;
      case "sumo_plan2":
        return <OpticksPillSumo50 {...sizeProps} />;
      case "sumo_plan3":
        return <OpticksPillSumo100 {...sizeProps} />;
      case "sumo_plan4":
        return <OpticksPillSumo300 {...sizeProps} />;
      case "sumo_plan5":
        return <OpticksPillSumo500 {...sizeProps} />;
      case "sumo_plan6":
        return <OpticksPillSumo1M {...sizeProps} />;
      default:
        return null;
    }
  };

  if (withLink) {
    return (
      <div
        className="opticks-plan-pill-indicator cursor-pointer"
        style={{ display: display || "flex" }}
        onClick={() =>
          navigate(routesMap.account.subscriptionCenter.path, {
            state: { clearFeatureScreen: true },
          })
        }
      >
        {renderPlanPill()}
      </div>
    );
  }

  return (
    <div
      className="opticks-plan-pill-indicator"
      style={{ display: display || "flex" }}
    >
      {loading ? (
        <OpticksSkeletonContainer width={72} height={30} isRounded />
      ) : (
        renderPlanPill()
      )}
    </div>
  );
};

export default OpticksPlanPillIndicator;
